import { AceTeamMemberDto } from './ace-team-member.dto';
import { permissionForRoles, TeamMember, TeamRole } from '../team-member.model';
import { resolveAvatarUrl } from 'src/app/shared/utils/avatar-url';

// ACE's role strings -> our enum. An ACE rename is absorbed here and nowhere
// else; an unrecognised role maps to Unknown rather than leaking ACE's vocabulary
// into the app.
const ROLE_MAP: Record<string, TeamRole> = {
  ADMIN: TeamRole.Admin,
  OPS: TeamRole.Ops,
  GP: TeamRole.Gp,
  LP: TeamRole.Lp,
  SUPPORTER: TeamRole.Supporter,
};

/**
 * Translate an ACE team member DTO into the app's TeamMember model. This is the
 * one place that knows about ACE's field names and the appRoles/roles quirk.
 */
export function toTeamMember(
  dto: AceTeamMemberDto,
  opts: { isCurrentUser?: boolean } = {}
): TeamMember {
  // /team/members sends `appRoles`; /users/me sends `roles`. Collapse both here.
  const rawRoles = (dto.appRoles ?? dto.roles ?? [])
    .filter((role): role is string => typeof role === 'string')
    .map(role => role.trim());
  const roles = rawRoles.map(
    role => ROLE_MAP[role.toUpperCase()] ?? TeamRole.Unknown
  );

  return {
    id: dto.id,
    firstName: dto.firstName ?? '',
    lastName: dto.lastName ?? '',
    email: dto.email ?? '',
    roles,
    permission: permissionForRoles(rawRoles),
    phone: dto.phone,
    location: dto.location,
    position: dto.position,
    dateOfBirth: dto.dateOfBirth,
    avatarUrl: resolveAvatarUrl(dto.profileImageUrl),
    isCurrentUser: opts.isCurrentUser ?? false,
  };
}
